module.exports = __webpack_public_path__ + "static/media/headstorm-atlas.321126d3.svg";